import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { OneTimeCodePage } from '../../pages/one-time-code/OneTimeCodePage';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { ROUTES } from '../../../../Routes';
import PageConfig from '../../../../services/userflow/PageConfig';
import { navigateToErrorPage } from '../../pages/error/ErrorNavigation';
import * as ConfigService from '../../../../config/ConfigService';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { FeatureSwitch } from '@origin-digital/features';
import { LiveChat } from 'ts/components/LiveChat';

interface ManualRegOneTimeCodePageProps {
  history: any;
}

const config: PageConfig = {
  startRoute: ROUTES.REGISTER_ENTER_USERNAME,
  errorType: ErrorFlow.register,
  analytics: { pageName: 'manual-reg-OTC', taskName: 'auth:manual-reg' },
};

const navigateToErrorPageAction = (history) => () => {
  navigateToErrorPage(
    ERROR_CODES.MANUAL_REG_OTC_ERROR,
    ErrorFlow.manualReg,
    ConfigService.getRegisterBootstrapUrl(),
    history,
  );
};

const ManualRegOneTimeCodePage: React.FC<ManualRegOneTimeCodePageProps> = ({ history }) => (
  <>
    <OneTimeCodePage
      history={history}
      flow={FlowType.manualReg}
      config={config}
      navigateToErrorPage={navigateToErrorPageAction(history)}
      showChangeEmailLink={true}
    />
    <FeatureSwitch name="sales-r2d2-manualregotc-livechat">
      <LiveChat />
    </FeatureSwitch>
  </>
);

export { ManualRegOneTimeCodePage };
